import {  isRep, isRepManagingClub } from './userRoleHelper';

export const showIndexNavigation = () => {
  return !isRep() || isRepManagingClub()
};

export const showRezzilPlayerNavigation = () => {
  return !isRep() || isRepManagingClub()
};
